import React from "react";

export default function SyncErrorMessage(errors) {
  return (
    <div>
      {errors.map((error) => (
        <p key={error.message}>{error.message}</p>
      ))}
    </div>
  );
}
